import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const EditBox = styled(Box)`
  height: 100%;
  padding: 24px;
  background-color: ${({ theme }) => theme.palette.white['01']};
`;

export const EditDrawerStack = styled(Stack)`
  flex-direction: column;
  gap: 16px;
  height: 100%;
  justify-content: flex-start;
`;
